import { Id, PagedMultiSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC, useMemo } from "react";
import { createUserRolesService } from "../api/userService";

interface Props {
	name: string;
	label: string;
	required?: boolean;
	userId: Id;
	idsToRemove?: Id[];
}
export const UserRoleMultiSelect: FC<Props> = ({ name, label, required, userId }) => {
	const service = useMemo(() => createUserRolesService(userId), [userId]);

	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			required={required}
			fetchConfig={laravelSelectFetchConfig(service.roleOptionsByUserKey, (search, page) =>
				service.roleOptionsByUser(search, page).then((x) => x.data),
			)}
		/>
	);
};
